import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de4eff1d363bb9/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExpertiseStatsSection"] */ "/tmp/8de4eff1d363bb9/components/sections/ExpertiseStatsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQSection"] */ "/tmp/8de4eff1d363bb9/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de4eff1d363bb9/components/sections/FeaturesCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de4eff1d363bb9/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KioskFeatures"] */ "/tmp/8de4eff1d363bb9/components/sections/KioskFeatures.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QRCaseStudy"] */ "/tmp/8de4eff1d363bb9/components/sections/QRCaseStudy.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QRLocations"] */ "/tmp/8de4eff1d363bb9/components/sections/QRLocations.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QRShowcase"] */ "/tmp/8de4eff1d363bb9/components/sections/QRShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SolutionComparison"] */ "/tmp/8de4eff1d363bb9/components/sections/SolutionComparison.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SolutionsGrid"] */ "/tmp/8de4eff1d363bb9/components/sections/SolutionsGrid.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de4eff1d363bb9/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4eff1d363bb9/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4eff1d363bb9/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4eff1d363bb9/components/ui/Button.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4eff1d363bb9/components/sections/VenuesSlider.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4eff1d363bb9/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de4eff1d363bb9/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de4eff1d363bb9/node_modules/next/dist/client/script.js");
